export const ArrivalDate = [
    { name: '21-02-2025', code: '2025-02-21' },
    { name: '22-02-2025', code: '2025-02-22' },
    { name: '23-02-2025', code: '2025-02-23' },
    { name: '24-02-2025', code: '2025-02-24' },
]